import { MyListingResolver } from './my-listing.resolver';
import { ListingDetailsResolver } from '../listing/resolvers/listing-details.resolver';
import { PreferenceComponent } from './containers/preference/preference.component';
import { SecurityComponent } from './containers/security/security.component';
import { NotifierModule } from 'angular-notifier';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileInfoComponent } from './containers/profile-info/profile-info.component';
import { MyListingComponent } from './containers/my-listing/my-listing.component';
import { DetailsComponent } from './containers/details/details.component';
import { AddCardComponent } from './containers/stripe/add-card/add-card.component';
import { HttpClientModule } from '@angular/common/http';
import { NgxLoadingModule } from 'ngx-loading';
import { CardListingComponent } from './containers/card-listing/card-listing.component';
import { StripeAccountComponent } from './containers/stripe/stripe-account/stripe-account.component';
import { StripeSettingsComponent } from './containers/stripe-settings/stripe-settings.component';
import { RouterModule } from '@angular/router';
import { StripeExternalComponent } from './containers/stripe/stripe-external/stripe-external.component';
import { SharedModule } from '@app/shared/shared.module';
import { TaskResolver } from '../listing/resolvers/listing.resolver';
import { TermsOfAgreementComponent } from '@app/shared/components/terms-of-agreement/terms-of-agreement.component';
import { profileRoutes } from './profile.routes';
import { AngularFireStorage, AngularFireStorageModule } from '@angular/fire/storage';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { ProfileComponent } from './profile.component';
import {MatTabsModule} from '@angular/material/tabs';
import { StripePayoutSettingsComponent } from './containers/stripe/stripe-payout-settings/stripe-payout-settings.component';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
  declarations: [
    ProfileInfoComponent,
    MyListingComponent,
    DetailsComponent,
    AddCardComponent,
    CardListingComponent,
    TermsOfAgreementComponent,
    StripeSettingsComponent,
    StripeAccountComponent,
    StripeExternalComponent,
    SecurityComponent,
    PreferenceComponent,
    ProfileComponent,
    StripePayoutSettingsComponent
  ],
  imports: [
    RouterModule.forChild(profileRoutes),
    NgxLoadingModule.forRoot({}),
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFireStorageModule,
    SharedModule,

    MatCheckboxModule,
    MatButtonModule,
    MatFormFieldModule,
    MatRadioModule,
    MatInputModule,
    MatRippleModule,
    MatNativeDateModule,
    MatSelectModule,
    MatDatepickerModule,
    MatIconModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatBottomSheetModule,
    MatPaginatorModule,
    MatCardModule,
    MatChipsModule,
    MatSidenavModule,
    MatListModule,
    MatTabsModule,
    MatExpansionModule,

    NotifierModule,
    MatTooltipModule,
    HttpClientModule,
    NgxLoadingModule
  ],
  providers: [TaskResolver, ListingDetailsResolver, MyListingResolver],
  entryComponents: [
    AddCardComponent,
    CardListingComponent,
    TermsOfAgreementComponent,
    StripeAccountComponent,
    StripeExternalComponent
  ],
  exports: [AddCardComponent]
})
export class ProfileModule { }
